import { AxiosError, AxiosRequestConfig } from 'axios'

export const handleFulfilled = (config: AxiosRequestConfig) => {
  return config
}

export const handleRejected = (error: AxiosError) => {
  return Promise.reject(error)
}


